//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  data () {
    return {
      showIndex: 0,
      nowDate: new Date().getTime()
    }
  },
  computed: {
    ...mapState({
      pluginShow: 'pluginShow',
      mobile: 'mobile',
      usergetCountry: 'usergetCountry'
    }),
    chromePlugin () {
      return this.$Cookie.get('chromePlugin')
    }
  },
  created () {
    this.$store.commit('setPluginShow', false)
  },
  mounted () {
    this.initPlugin()
  },
  methods: {
    initPlugin () {
      // 已安装插件
      if (document.querySelector('#jflkdlbjgfiifajbjeockfjhbnhlakfd') && document.querySelector('#jflkdlbjgfiifajbjeockfjhbnhlakfd').length > 0) return false
      if (this.$route.name !== 'lang-dealer-id' && this.$route.name !== 'lang') return false
      if (this.mobile || this.browser() !== 'Chrome') return false
      // 如果不存在cooike就显示,并存储cookie
      if (this.chromePlugin && Number(this.chromePlugin) <= 3) {
        if (Number(this.chromePlugin) >= 3) return false
        let N = this.chromePlugin
        N = Number(N) + 1
        this.$store.commit('setPluginShow', true)
        this.$Cookie.set('chromePlugin', N)
      } else if (!this.chromePlugin) {
        this.$store.commit('setPluginShow', true)
        this.$Cookie.set('chromePlugin', 1, { expires: 1 })
      }
    },
    closePlugin () {
      this.$store.commit('setPluginShow', false)
    },
    toDownload () {
      if (this.usergetCountry.countryCode == 156) {
        window.open(`https://plugins.${this.$store.state.newhost}.com/trade/index.html`)
      } else {
        window.open('https://chrome.google.com/webstore/detail/wikifx/jflkdlbjgfiifajbjeockfjhbnhlakfd')
      }
    },
    browser () {
      // 取得浏览器的userAgent字符串
      const userAgent = navigator.userAgent
      // 判断是否Opera浏览器
      const isOpera = userAgent.includes('Opera')
      // 判断是否IE浏览器
      const isIE =
        userAgent.includes('compatible') &&
        userAgent.includes('MSIE') &&
        !isOpera
      // 判断是否IE的Edge浏览器
      const isEdge = userAgent.includes('Edge')
      // 判断是否Firefox浏览器
      const isFF = userAgent.includes('Firefox')
      // 判断是否Safari浏览器
      const isSafari =
        userAgent.includes('Safari') && !userAgent.includes('Chrome')
      // 判断Chrome浏览器
      const isChrome =
        userAgent.includes('Chrome') && userAgent.includes('Safari')

      if (isIE) {
        // const reIE = RegExp('MSIE (\\d+\\.\\d+);')
        // reIE.test(userAgent)
        const fIEVersion = parseFloat(RegExp.$1)
        if (fIEVersion === 7) {
          return 'IE7'
        } else if (fIEVersion === 8) {
          return 'IE8'
        } else if (fIEVersion === 9) {
          return 'IE9'
        } else if (fIEVersion === 10) {
          return 'IE10'
        } else if (fIEVersion === 11) {
          return 'IE11'
        } else {
          return 'IE'
        }
      }
      if (isOpera) {
        return 'Opera'
      }
      if (isEdge) {
        return 'Edge'
      }
      if (isFF) {
        return 'FF'
      }
      if (isSafari) {
        return 'Safari'
      }
      if (isChrome) {
        return 'Chrome'
      }
    }
  }
}
